import { type KnowledgeSource } from '../../types/ai';
import truncated from 'utils/wordsLength';

type PlaygroundSourcesPanelProps = {
  sources: KnowledgeSource[];
};

export const PlaygroundSourcesPanel = ({ sources }: PlaygroundSourcesPanelProps) => (
  <div className="rounded-xl border border-black/10 bg-white p-5 shadow-sm">
    <h3 className="text-base font-semibold text-brand-blue">Senaste källor</h3>
    <ul className="mt-3 space-y-2 text-sm text-brand-blue">
      {sources.map((source) => (
        <li key={source.id} className="rounded-md border border-black/10 bg-brand-beige-tint-1 p-3">
          <p className="font-medium text-brand-blue">{source.title}</p>
          {source.snippet ? (
            <p className="mt-1 text-xs text-text-grey">{truncated(source.snippet.trim(), 20)}</p>
          ) : null}
          {source.url ? (
            <a
              href={source.url}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-block text-xs font-semibold text-brand hover:text-brand-light"
            >
              Öppna källa
            </a>
          ) : null}
        </li>
      ))}
    </ul>
  </div>
);
